import React from 'react';
import { Tree as AntdTree, TreeProps as AntdTreeProps, ConfigProvider } from 'antd';
import { useTheme } from '../../theme/ThemeContext';

// Define the props type for your custom Tree component
export interface TreeProps extends AntdTreeProps { 'data-test'?: string; }

// Wrapper component for Tree
const Tree: React.FC<TreeProps> = (props) => {
    const theme = useTheme();
    return (
        <ConfigProvider theme={theme}>
            <AntdTree {...props} data-test={props['data-test']} data-asper-Tree/>
        </ConfigProvider>
    );
};

export default Tree;
